/**
 * Converts a string into a URL-safe slug.
 * Lowercases, trims, removes non-alphanumeric chars, and replaces spaces with hyphens.
 *
 * @param {string} str
 * @returns {string}
 */
export function slugify(str) {
	if (!str) return "";
	return str
		.toLowerCase()
		.trim()
		.replace(/[^a-z0-9\s-]/g, "")
		.replace(/\s+/g, "-")
		.replace(/-+/g, "-");
}

/**
 * Creates a SEO-friendly URL slug for a plant from its variety and name.
 * Example: createPlantSlug("Brandywine", "Tomato") => "brandywine-tomato"
 *
 * @param {string} variety - plant_variety field
 * @param {string} name    - plant_name field
 * @returns {string}
 */
export function createPlantSlug(variety, name) {
	const v = slugify(variety || "");
	const n = slugify(name || "");
	if (v && n) return `${v}-${n}`;
	return v || n;
}
